document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.product__accordion .details');

  accordions.forEach((detail) => {
    const summary = detail.querySelector('.summary');
    const content = detail.querySelector('.accordion__content');

    // Изначально закрываем
    content.style.maxHeight = '0px';

    summary.addEventListener('click', () => {
      const isOpen = detail.classList.contains('is-open');

      // Закрываем все остальные
      accordions.forEach((other) => {
        if (other !== detail) {
          other.classList.remove('is-open');
          other.querySelector('.accordion__content').style.maxHeight = '0px';
        }
      });

      // Переключаем текущий
      if (isOpen) {
        detail.classList.remove('is-open');
        content.style.maxHeight = '0px';
      } else {
        detail.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });

    // При ресайзе корректируем высоту открытого
    window.addEventListener('resize', () => {
      if (detail.classList.contains('is-open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});
